import { useMeleeContext } from "draft/context/MeleeContextProvider";
import { Grid } from "semantic-ui-react";

type Props = {
    PlayerField : any,
}

const basicMargin = {
    margin: '16px 0px 16px 0px'
}

const DuelForm = ({PlayerField} : Props) => {
    const context = useMeleeContext();

    return (
        <Grid className="player-form" columns={2} container stackable relaxed style={{ marginBottom: 24 }}>
        <Grid.Column>
            <div style={basicMargin}>
                <PlayerField
                    player={context!.players.find((p) => p.Number === 1)}
                />
            </div>
        </Grid.Column>
        <Grid.Column>
        <div style={basicMargin}>
                <PlayerField
                    player={context!.players.find((p) => p.Number === 2)}
                />
            </div>
        </Grid.Column>
    </Grid>
    )
};

export default DuelForm;